<script lang="ts">
  /** The Kip brand mark — a cobalt tile with a white egg (Split Roost logo). */
  let { size = 28 }: { size?: number } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  aria-hidden="true"
  class="egg-mark"
>
  <rect width="24" height="24" rx="6" fill="var(--rooster)" />
  <path
    d="M12 5.2c-2.2 0-4.6 3.4-4.6 7 0 2.8 2 4.6 4.6 4.6s4.6-1.8 4.6-4.6c0-3.6-2.4-7-4.6-7Z"
    fill="#fff"
    fill-opacity="0.92"
  />
  <circle cx="12" cy="12.4" r="1.7" fill="var(--rooster)" />
</svg>

<style>
  .egg-mark {
    display: block;
  }
</style>
